module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAASElEQVR42t2OQQoAIAjA+v8P+oKftC4yDxUlEtFoF8NheQPtb1fP5QDYjMDhMgEQnWkM/yGyLIkXaC26FPx8K4AQCiAkBP6gAdojfPhsvPeuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_nagorno-karabakh.png
// module id = 1316
// module chunks = 0